export default __webpack_public_path__ + "static/media/line_skeleton.713f4f08.png";